// import React, { useState, useRef, useEffect, useContext } from 'react';
// import { useTranslation } from 'react-i18next';
// import { useNavigate } from 'react-router-dom';
// import { ConfigContext } from '../../Context/ConfigContext';
// import Swal from 'sweetalert2';
// import { FiX } from "react-icons/fi";

// const MobileSearchBar = () => {
//     const { t } = useTranslation();

//     const [keyword, setKeyword] = useState('');
//     const [selectedText, setSelectedText] = useState('');
//     const [searchResults, setSearchResults] = useState([]);
//     const [loading, setLoading] = useState(false);

//     const navigate = useNavigate();
//     const modalRef = useRef(null);
//     const { gdcURL } = useContext(ConfigContext);

//     const lang = localStorage.getItem('lang');
//     const dir = localStorage.getItem('dir');

//     // 🔹 Show Modal
//     const showModal = () => {
//         const modal = new window.bootstrap.Modal(modalRef.current);
//         modal.show();
//     };

//     // 🔹 Hide Modal
//     const hideModal = () => {
//         const modalElement = modalRef.current;
//         modalElement.classList.remove('show');
//         modalElement.style.display = 'none';
//         document.body.classList.remove('modal-open');
//         const backdrop = document.querySelector('.modal-backdrop');
//         if (backdrop) backdrop.remove();
//     };

//     // 🔹 API Call
//     useEffect(() => {
//         if (keyword !== '') {
//             setLoading(true);

//             fetch(
//                 `${gdcURL}/Gen/Search?keyword=${keyword.trim().replace(/[^a-zA-Z0-9\s]/g, '')}&pc_id=${localStorage.getItem("pc_id")}&lang=${lang}`
//             )
//                 .then(res => res.json())
//                 .then(data => {
//                     setLoading(false);

//                     const docs = data.response.docs;

//                     const uniqueDocs = Array.from(
//                         new Map(docs.map(doc => [doc.SEARCH_TITLE.join('|'), doc])).values()
//                     );

//                     setSearchResults(uniqueDocs);
//                 });
//         } else {
//             setSearchResults([]);
//         }
//     }, [keyword, gdcURL, lang]);

//     const handleChange = (e) => {
//         setKeyword(e.target.value);
//     };

//     // 🔹 Navigation
//     const navigateHandle = (part) => {
//         const title = Array.isArray(part.SEARCH_TITLE)
//             ? part.SEARCH_TITLE[0]
//             : part.SEARCH_TITLE;

//         setSelectedText(title);
//         setKeyword(title);

//         hideModal();

//         if (part.SEARCH_TYPE === 'CATEGORY') {
//             navigate(localStorage.getItem('pc_id')
//                 ? `/Spare-Parts/${part.SEARCH_URL}`
//                 : `/Spare-Parts/Spare-Parts-nocar/${part.STR_ID}/${part.SEARCH_URL}`
//             );

//         } else if (part.SEARCH_TYPE === 'IAMNumber') {
//             navigate(`/Spare-Parts/Details/${part.SEARCH_URL}`);

//         } else if (part.SEARCH_TYPE === 'OENumber') {
//             const slug = title.replace(/[^a-zA-Z0-9\s]/g, '').replace(/ /g, '-');
//             const partNumber = title.split(' ').pop().replace(/[^a-zA-Z0-9\s]/g, '');

//             navigate(`Spare-Parts/OEM/${part.ART_ID}/${partNumber}/${slug}`);

//         } else if (part.SEARCH_TYPE === 'PRODUCTS') {
//             navigate(part.SEARCH_URL);
//         }
//     };

//     // 🔹 Search Button
//     const onSearchClick = () => {
//         if (!loading && searchResults.length === 0) {
//             Swal.fire({
//                 title: t('error'),
//                 text: t('no_result'),
//                 icon: "error",
//                 confirmButtonText: "Okay",
//             });
//         } else if (searchResults.length > 0) {
//             navigateHandle(searchResults[0]);
//         }
//     };

//     const clearSearch = () => {
//         setKeyword('');
//         setSelectedText('');
//         setSearchResults([]);
//     };

//     return (
//         <div style={{ backgroundColor: '#132531', marginTop: '-2px' }}>

//             {/* 🔹 Modal */}
//             <div
//                 className="modal fade"
//                 ref={modalRef}
//                 tabIndex={-1}
//                 style={{
//                     zIndex: 1050000000,
//                     backgroundColor: 'rgba(0,0,0,0.5)'
//                 }}
//             >
//                 <div className="modal-dialog modal-dialog-centered modal-sm">
//                     <div className="modal-content">
//                         <div className="modal-body">

//                             {/* 🔥 INPUT GROUP (APPEND SAME AS DESKTOP) */}
//                             <div className="input-group position-relative">

//                                 <input
//                                     type="text"
//                                     className="form-control"
//                                     placeholder={t("enter_part_number_name")}
//                                     value={keyword}
//                                     onChange={handleChange}
//                                     onKeyDown={(e) => {
//                                         if (e.key === 'Enter') {
//                                             onSearchClick();
//                                         }
//                                     }}
//                                 />

//                                 <div className="input-group-append">

//                                     {/* ❌ CLEAR */}
//                                     {keyword && (
//                                         <span
//                                             onClick={clearSearch}
//                                             className="input-group-text"
//                                             style={{
//                                                 backgroundColor: '#f4f4f4',
//                                                 cursor: 'pointer'
//                                             }}
//                                         >
//                                             <FiX />
//                                         </span>
//                                     )}

//                                     {/* 🔍 SEARCH BUTTON */}
//                                     <button
//                                         onClick={onSearchClick}
//                                         className="btn btn-primary"
//                                         type="button"
//                                     >
//                                         {t("search")}
//                                     </button>

//                                 </div>
//                             </div>

//                             {/* 🔹 RESULTS */}
//                             <div style={{
//                                 background: '#fff',
//                                 maxHeight: '300px',
//                                 overflowY: 'auto'
//                             }}>
//                                 {loading && (
//                                     <div className="text-center p-2">Loading...</div>
//                                 )}

//                                 {!loading && searchResults.length === 0 && keyword && (
//                                     <div className="text-danger text-center p-2">
//                                         {t('no_result')}
//                                     </div>
//                                 )}

//                                 <table className="table mb-0">
//                                     {searchResults.map((item, index) => (
//                                         <tr
//                                             key={index}
//                                             style={{ cursor: 'pointer' }}
//                                             onClick={() => navigateHandle(item)}
//                                         >
//                                             <td>{item.SEARCH_TITLE}</td>
//                                         </tr>
//                                     ))}
//                                 </table>
//                             </div>

//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* 🔹 MAIN INPUT */}
//             <div className="d-inline-flex align-items-center w-100 pl-2 pr-2">

//                 <input
//                     type="text"
//                     placeholder={t("enter_part_number_name")}
//                     className="form-control flex-grow-1"
//                     value={selectedText}
//                     readOnly
//                     onClick={showModal}
//                 />

//                 {/* ❌ RESET */}
//                 {selectedText && (
//                     <button
//                         className="btn btn-light ml-1"
//                         onClick={clearSearch}
//                     >
//                         ❌
//                     </button>
//                 )}

//                 <button
//                     className="btn btn-primary ml-2"
//                     onClick={showModal}
//                     style={{ marginTop: '-10px' }}
//                 >
//                     <i className="fas fa-search"></i>
//                 </button>
//             </div>
//         </div>
//     );
// };

// export default MobileSearchBar;


import React, { useState, useRef, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ConfigContext } from '../../Context/ConfigContext';
import Swal from 'sweetalert2';
import { FiX } from "react-icons/fi";

const MobileSearchBar = () => {
    const { t } = useTranslation();

    const [keyword, setKeyword] = useState('');
    const [selectedText, setSelectedText] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const modalRef = useRef(null);
    const { gdcURL } = useContext(ConfigContext);

    const lang = localStorage.getItem('lang');

    // 🔹 Show Modal
    const showModal = () => {
        const modal = new window.bootstrap.Modal(modalRef.current);
        modal.show();
    };

    // 🔹 Hide Modal
    const hideModal = () => {
        const modalElement = modalRef.current;
        modalElement.classList.remove('show');
        modalElement.style.display = 'none';
        document.body.classList.remove('modal-open');
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) backdrop.remove();
    };

    // 🔹 API Call
    useEffect(() => {
        if (keyword !== '') {
            setLoading(true);

            fetch(
                `${gdcURL}/Gen/Search?keyword=${keyword.trim().replace(/[^a-zA-Z0-9\s]/g, '')}&pc_id=${localStorage.getItem("pc_id")}&lang=${lang}`
            )
                .then(res => res.json())
                .then(data => {
                    setLoading(false);

                    const docs = data.response.docs;

                    const uniqueDocs = Array.from(
                        new Map(docs.map(doc => [doc.SEARCH_TITLE.join('|'), doc])).values()
                    );

                    setSearchResults(uniqueDocs);
                });
        } else {
            setSearchResults([]);
        }
    }, [keyword, gdcURL, lang]);

    const handleChange = (e) => {
        setKeyword(e.target.value);
    };

    // 🔹 Navigation
    const navigateHandle = (part) => {
        const title = Array.isArray(part.SEARCH_TITLE)
            ? part.SEARCH_TITLE[0]
            : part.SEARCH_TITLE;

        // 👉 show in main input
        setSelectedText(title);

        // 👉 reset modal input
        setKeyword('');
        setSearchResults([]);

        hideModal();

        if (part.SEARCH_TYPE === 'CATEGORY') {
            navigate(localStorage.getItem('pc_id')
                ? `/Spare-Parts/${part.SEARCH_URL}`
                : `/Spare-Parts/Spare-Parts-nocar/${part.STR_ID}/${part.SEARCH_URL}`
            );

        } else if (part.SEARCH_TYPE === 'IAMNumber') {
            navigate(`/Spare-Parts/Details/${part.SEARCH_URL}`);

        } else if (part.SEARCH_TYPE === 'OENumber') {
            const slug = title.replace(/[^a-zA-Z0-9\s]/g, '').replace(/ /g, '-');
            const partNumber = title.split(' ').pop().replace(/[^a-zA-Z0-9\s]/g, '');

            navigate(`Spare-Parts/OEM/${part.ART_ID}/${partNumber}/${slug}`);

        } else if (part.SEARCH_TYPE === 'PRODUCTS') {
            navigate(part.SEARCH_URL);
        }
    };

    // 🔹 Search click
    const onSearchClick = () => {
        if (!loading && searchResults.length === 0) {
            Swal.fire({
                title: t('error'),
                text: t('no_result'),
                icon: "error",
                confirmButtonText: "Okay",
            });
        } else if (searchResults.length > 0) {
            navigateHandle(searchResults[0]);
        }
    };

    const clearSearch = () => {
        setSelectedText('');
        setKeyword('');
        setSearchResults([]);
    };

    return (
        <div style={{ backgroundColor: '#132531', marginTop: '-2px' }}>

            {/* 🔹 Modal */}
            <div
                className="modal fade"
                ref={modalRef}
                tabIndex={-1}
                style={{
                    zIndex: 1050000000,
                    backgroundColor: 'rgba(0,0,0,0.5)'
                }}
            >
                <div className="modal-dialog modal-dialog-centered modal-sm">
                    <div className="modal-content">
                        <div className="modal-body">

                            {/* 🔥 Modal Input Group */}
                            <div className="input-group mb-2">

                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder={t("enter_part_number_name")}
                                    value={keyword}
                                    onChange={handleChange}
                                    autoFocus
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            onSearchClick();
                                        }
                                    }}
                                />

                                <div className="input-group-append">

                                    {/* ❌ clear */}
                                    {keyword && (
                                        <span
                                            onClick={() => {
                                                setKeyword('');
                                                setSearchResults([]);
                                            }}
                                            className="input-group-text"
                                            style={{
                                                backgroundColor: '#f4f4f4',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <FiX />
                                        </span>
                                    )}

                                    {/* 🔍 search */}
                                    <button
                                        className="btn btn-primary"
                                        onClick={onSearchClick}
                                    >
                                        <i className="fas fa-search"></i>
                                    </button>

                                </div>
                            </div>

                            {/* 🔹 Results */}
                            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                {loading && <div className="text-center">Loading...</div>}

                                {!loading && searchResults.length === 0 && keyword && (
                                    <div className="text-danger text-center">
                                        {t('no_result')}
                                    </div>
                                )}

                                <table className="table mb-0">
                                    {searchResults.map((item, index) => (
                                        <tr
                                            key={index}
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => navigateHandle(item)}
                                        >
                                            <td>{item.SEARCH_TITLE}</td>
                                        </tr>
                                    ))}
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {/* 🔥 MAIN INPUT */}
            <div className="input-group position-relative p-2">

                <input
                    type="text"
                    className="form-control"
                    placeholder={t("enter_part_number_name")}
                    value={selectedText}
                    readOnly
                    onClick={showModal}
                />

                <div className="input-group-append">

                    {/* ❌ Reset */}
                    {selectedText && (
                        <span
                            onClick={clearSearch}
                            className="input-group-text"
                            style={{
                                backgroundColor: '#f4f4f4',
                                cursor: 'pointer'
                            }}
                        >
                            <FiX />
                        </span>
                    )}

                    {/* 🔍 Search */}
                    <button
                        className="btn btn-primary"
                        onClick={showModal}
                    >
                        <i className="fas fa-search"></i>
                    </button>

                </div>
            </div>

        </div>
    );
};

export default MobileSearchBar;